module.exports = __webpack_public_path__ + "img/slide4.35b88e97.jpg";